import React, { useState, useEffect, useContext } from "react";
import firebase from "../../services/firebase";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import { Badge, Grid, Box, Link } from "@material-ui/core";
import AppBar from "@material-ui/core/AppBar";
import CssBaseline from "@material-ui/core/CssBaseline";
import Divider from "@material-ui/core/Divider";
import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";
import IconButton from "@material-ui/core/IconButton";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import MenuIcon from "@material-ui/icons/Menu";
import Toolbar from "@material-ui/core/Toolbar";
import {
    Favorite,
    LocalDining,
    LocalOffer,
    EmojiFoodBeverage,
    History,
    LocalMall,
    LocalDrink,
    LocalCafe,
    LocalBar,
} from "@material-ui/icons";
import Typography from "@material-ui/core/Typography";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { UserContext, OrderContext } from "../../context";
import { LoginBtn, LogoutBtn, Avatar, NoSaleAlert } from "..";
import { useStatisticVariables } from "../../services/firestore";
import {
    getPartnerName,
    getOrderNum,
    isPartnerDev,
    isDev,
    isDeveloperDev,
} from "../../helpers";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
        color: theme.palette.root,
    },
    drawer: {
        [theme.breakpoints.up("sm")]: {
            width: drawerWidth,
            flexShrink: 0,
        },
    },
    appBar: {
        [theme.breakpoints.up("sm")]: {
            width: `calc(100% - ${drawerWidth}px)`,
            marginLeft: drawerWidth,
        },
    },
    TopGridItem: {
        alignItems: "center",
    },
    menuButton: {
        [theme.breakpoints.up("sm")]: {
            display: "none",
        },
    },
    titleTypography: {
        marginTop: "auto",
    },
    // necessary for content to be below app bar
    toolbar: theme.mixins.toolbar,
    drawerPaper: {
        width: drawerWidth,
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(2),
    },
}));

const DrawerList = (objList, setMobileOpen) =>
    objList.map((pair) => {
        let text = pair.type;
        let txtIcon = pair.icon;
        return (
            <ListItem
                component={NavLink}
                to={pair.navlink ? pair.navlink : "/"}
                button
                key={text}
                onClick={() => {
                    setMobileOpen(false);
                    pair.onClick();
                }}
            >
                <ListItemIcon>{txtIcon}</ListItemIcon>
                <ListItemText primary={text} />
            </ListItem>
        );
    });

function ResponsiveDrawer(props) {
    const { user, setUser } = useContext(UserContext);
    const { orders } = useContext(OrderContext);
    const { deliverMenu } = useStatisticVariables();
    const { container } = props;
    const classes = useStyles();
    const theme = useTheme();
    const [mobileOpen, setMobileOpen] = React.useState(false);

    const [notSaleAlert, setNotSaleAlert] = useState(false);

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    const DRAWER_FOOD_LIST = () => [
        {
            type: "Vorspeise",
            icon: <EmojiFoodBeverage />,
            onClick: () =>
                props.setMenuPart({ first: "normal", second: "Vorspeise" }),
        },
        {
            type: "Hauptspeise",
            icon: <LocalDining />,
            onClick: () =>
                props.setMenuPart({ first: "normal", second: "Hauptspeise" }),
        },
        {
            type: "Sushi",
            icon: <LocalDining />,
            onClick: () =>
                props.setMenuPart({ first: "normal", second: "Sushi" }),
        },
        {
            type: "Sushiset",
            icon: <LocalDining />,
            onClick: () =>
                props.setMenuPart({ first: "normal", second: "Sushiset" }),
        },
        {
            type: "Mittagstisch",
            icon: <LocalOffer />,
            onClick: () => {
                props.isSale
                    ? props.setMenuPart({
                          first: "discount",
                          second: "Angebote",
                      })
                    : setNotSaleAlert(true);
            },
        },
    ];

    const DRAWER_DRINKS_LIST = () => {
        if (deliverMenu)
            return [
                ...Object.keys(deliverMenu.drinks).map((key) => {
                    return {
                        type: key,
                        icon: softDrinkTypes.includes(key) ? (
                            <LocalCafe />
                        ) : (
                            <LocalBar />
                        ),
                        onClick: () => {
                            props.setMenuPart({
                                first: "drinks",
                                second: key,
                            });
                        },
                    };
                }),
            ];
        return [];
    };

    const DRAWER_TOOLS_LIST = () => [
        {
            type: "Einkaufskorb",
            navlink: "/checkout",
            icon: (
                <Badge badgeContent={getOrderNum(orders)} color="secondary">
                    <LocalMall />
                </Badge>
            ),
            onClick: () => null,
        },
        {
            type: "Favoriten",
            navlink: "/favorite",
            icon: <Favorite />,
            onClick: () => null,
        },
        {
            type: "Meine Bestellungen",
            navlink: "/history",
            icon: <History />,
            onClick: () => null,
        },
    ];

    const TopToolbar = (props) => (
        <Toolbar>
            <Grid
                container
                spacing={3}
                justify="space-between"
                alignItems="center"
                direction="row"
            >
                <Grid
                    item
                    container
                    style={{ padding: 0, width: 40 }}
                    justify="center"
                >
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        edge="start"
                        onClick={handleDrawerToggle}
                        className={classes.menuButton}
                    >
                        <MenuIcon />
                    </IconButton>
                </Grid>
                <Grid
                    item
                    container
                    xs={9}
                    sm={10}
                    md={6}
                    spacing={2}
                    justify="center"
                >
                    <Grid item>
                        <Link
                            href={`http://${getPartnerName().toLowerCase()}-restaurant.de/`}
                        >
                            <img
                                src={`/logo/${getPartnerName().toLowerCase()}-white.png`}
                                height="40px"
                                alt={`${getPartnerName()} Logo`}
                            />
                        </Link>
                    </Grid>
                    <Grid item>
                        {(isDeveloperDev ||
                            (isPartnerDev &&
                                getPartnerName().toLowerCase() ===
                                    "taumi")) && (
                            <Typography
                                variant="overline"
                                color="initial"
                                style={{ fontSize: "1rem" }}
                            >
                                Karlsruhe
                            </Typography>
                        )}
                    </Grid>
                </Grid>
                <Grid item style={{ padding: 0, width: 40 }}>
                    <Avatar
                        src={
                            props.user.isSignedIn
                                ? firebase.auth().currentUser.photoURL
                                : isDeveloperDev
                                ? "https://avatars.dicebear.com/v2/male/hi.svg"
                                : null
                        }
                        username={
                            props.user.isSignedIn
                                ? firebase.auth().currentUser.displayName
                                : null
                        }
                        className={classes.avatar}
                    />
                </Grid>
            </Grid>
        </Toolbar>
    );

    const drawer = (
        <div>
            <div className={classes.toolbar} />
            <Divider />
            <List>{DrawerList(DRAWER_FOOD_LIST(props), setMobileOpen)}</List>
            <Divider />
            <List>{DrawerList(DRAWER_DRINKS_LIST(props), setMobileOpen)}</List>
            <Divider />
            <List>{DrawerList(DRAWER_TOOLS_LIST(props), setMobileOpen)}</List>
            <Divider />
            <List>
                <ListItem>
                    {user.isSignedIn ? <LogoutBtn setUser={setUser} /> : null}
                </ListItem>
            </List>
        </div>
    );

    return (
        <div className={classes.root}>
            {notSaleAlert ? (
                <NoSaleAlert
                    setOpen={setNotSaleAlert}
                    noSaleExplaination={props.noSaleExplaination}
                />
            ) : null}
            <CssBaseline />
            <AppBar position="fixed" className={classes.appBar}>
                <TopToolbar user={user} />
            </AppBar>
            <nav className={classes.drawer} aria-label="mailbox folders">
                {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
                <Hidden smUp implementation="css">
                    <Drawer
                        container={container}
                        variant="temporary"
                        anchor={theme.direction === "rtl" ? "right" : "left"}
                        open={mobileOpen}
                        onClose={handleDrawerToggle}
                        classes={{
                            paper: classes.drawerPaper,
                        }}
                        ModalProps={{
                            keepMounted: true, // Better open performance on mobile.
                        }}
                    >
                        {drawer}
                    </Drawer>
                </Hidden>
                <Hidden xsDown implementation="css">
                    <Drawer
                        classes={{
                            paper: classes.drawerPaper,
                        }}
                        variant="permanent"
                        open
                    >
                        {drawer}
                    </Drawer>
                </Hidden>
            </nav>
            <main className={classes.content}>
                <div className={classes.toolbar} />
                {user.isSignedIn ? null : <LoginBtn />}
                {props.children}
            </main>
        </div>
    );
}

const softDrinkTypes = [
    "Tee",
    "Koffee",
    "Hausgemachte Frische Getränke",
    "Kalte Getränke",
    "Softdrinks",
];

const alcoholDrinkTypes = [
    "Bier",
    "Asiatische Getränke",
    "Offene Weine (0.2L)",
    "Flaschenwein (0.75L)",
    "Alkoholsgetränke",
];

export default ResponsiveDrawer;
